import React from 'react';
import Language from '../../../common/decorators/Language';
import Single from '../../../layouts/single/Single/Single';
import { getDefaultStaticProps, getLangPaths } from '../../api/_props';
import { t } from '../../../common/components/T';
import ContactGT from '../../../views/contact/ContactGT/ContactGT';
const project = require('../../../scripts/configs/project');
import css from '../../../views/contact/ContactGT/ContactGT.module.scss';

const ContactInfo = ({ translates }) => {
    return (
        <Language translates={translates} page={'/contact'}>
            <Single
                alias={'contact'}
                title={t('mainPageTitle-contact', 'Контакты', '/contact', translates)}
                translates={translates}
                secondFooter={true}
                compStyles={{ mainWrapper: css.mainWrapperContact }}
            >
                <ContactGT />
            </Single>
        </Language>
    );
};
export async function getStaticProps({ params }) {
    const defaultProps = await getDefaultStaticProps(params?.lang, '/contact', ['/']);
    if (!defaultProps?.props) {
        return defaultProps;
    }

    return {
        props: {
            ...defaultProps?.props
        },
        revalidate: project?.revalidate
    };
}
export async function getStaticPaths() {
    const paths = await getLangPaths();
    return {
        paths,
        fallback: true
    };
}
export default ContactInfo;
